function index() {
  return import(/* webpackChunkName: "page-index" */ '@/pages/index.vue')
}
function hakkimizda() {
  return import(
    /* webpackChunkName: "page-hakkimizda" */ '@/pages/hakkimizda.vue'
  )
}
function profil() {
  return import(/* webpackChunkName: "page-profil" */ '@/pages/profil.vue')
}
function profil_duzenle() {
  return import(
    /* webpackChunkName: "page-profil-duzenle" */ '@/pages/profil/duzenle.vue'
  )
}
function profil_guvenlik() {
  return import(
    /* webpackChunkName: "page-profil-guvenlik" */ '@/pages/profil/guvenlik.vue'
  )
}
function profil_panel() {
  return import(
    /* webpackChunkName: "page-profil-panel" */ '@/pages/profil/panel.vue'
  )
}
function profil__profile_hakkinda() {
  return import(
    /* webpackChunkName: "page-profil-profile-hakkinda" */ '@/pages/profil/_profile/hakkinda.vue'
  )
}
function profil__profile_ilanlar() {
  return import(
    /* webpackChunkName: "page-profil-profile-ilanlar" */ '@/pages/profil/_profile/ilanlar.vue'
  )
}
function ansiklopedi_index() {
  return import(
    /* webpackChunkName: "page-ansiklopedi-index" */ '@/pages/ansiklopedi/index.vue'
  )
}
function ilanlar_index() {
  return import(
    /* webpackChunkName: "page-ilanlar-index" */ '@/pages/ilanlar/index.vue'
  )
}
function ansiklopedi_kategori__category() {
  return import(
    /* webpackChunkName: "page-ansiklopedi-kategori-category" */ '@/pages/ansiklopedi/kategori/_category.vue'
  )
}
function ansiklopedi_oku__article() {
  return import(
    /* webpackChunkName: "page-ansiklopedi-oku-article" */ '@/pages/ansiklopedi/oku/_article.vue'
  )
}
function ilanlar__ad() {
  return import(
    /* webpackChunkName: "page-ilanlar-ad" */ '@/pages/ilanlar/_ad.vue'
  )
}

export default [
  {
    name: 'home',
    path: '',
    component: index,
  },
  {
    name: 'about',
    path: 'hakkimizda',
    component: hakkimizda,
  },
  {
    name: 'profile-container',
    path: 'profil',
    component: profil,
    meta: {
      authOnly: true,
    },
    children: [
      {
        name: 'my-edit',
        path: 'duzenle',
        component: profil_duzenle,
        meta: {
          authOnly: true,
        },
      },
      {
        name: 'my-security',
        path: 'guvenlik',
        component: profil_guvenlik,
        meta: {
          authOnly: true,
        },
      },
      {
        name: 'my-admin-panel',
        path: 'panel',
        component: profil_panel,
        meta: {
          authOnly: 'admin',
        },
      },
      {
        name: 'profile-about',
        path: ':profile/hakkinda',
        component: profil__profile_hakkinda,
      },
      {
        name: 'profile',
        path: ':profile/ilanlar',
        component: profil__profile_ilanlar,
      },
    ],
  },
  {
    name: 'articles',
    path: 'ansiklopedi',
    component: ansiklopedi_index,
  },
  {
    name: 'ads',
    path: 'ilanlar',
    component: ilanlar_index,
  },
  {
    name: 'article_category',
    path: 'ansiklopedi/kategori/:category?',
    component: ansiklopedi_kategori__category,
  },
  {
    name: 'article',
    path: 'ansiklopedi/oku/:article?',
    component: ansiklopedi_oku__article,
  },
  {
    name: 'ad',
    path: 'ilanlar/:ad?',
    component: ilanlar__ad,
  },
]
